import React from 'react'
import dayjs from 'dayjs'
import { DateRange } from 'react-day-picker'

export const useCalendarState = (initialValue?: DateRange) => {
    const [selected, setSelected] = React.useState<DateRange | undefined>(initialValue)
    const [month, setMonth] = React.useState<Date>(initialValue?.from || new Date())

    const handleMonthChange = (direction: 'next' | 'prev') => {
        setMonth(dayjs(month)[direction === 'next' ? 'add' : 'subtract'](1, 'month').toDate())
    }

    return { selected, month, setMonth, setSelected, handleMonthChange }
}
